import { useEffect, useState } from 'react';
import { getAuthToken } from '../services/authorize';

const cache = {};

const useTranslations = (keys = [], configuration, languageId = 'es_ES') => {
  const [translations, setTranslations] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTranslations = async () => {
      if (!configuration?.clientId || !configuration?.clientSecret || !configuration?.tokenUrl) {
        console.error('Faltan datos de configuración para autenticación');
        setLoading(false);
        return;
      }

      try {
        const missingKeys = keys.filter(key => !cache[key]);
        let token = null;

        if (missingKeys.length > 0) {
          token = await getAuthToken({
            clientId: configuration.clientId,
            clientSecret: configuration.clientSecret,
            tokenUrl: configuration.tokenUrl,
          });

          const fetches = missingKeys.map(async key => {
            const res = await fetch(`/o/language/v1.0/messages?key=${key}&languageId=${languageId}`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            cache[key] = data.value || key;
          });

          await Promise.all(fetches);
        }

        const result = {};
        keys.forEach(key => {
          result[key] = cache[key];
        });

        setTranslations(result);
      } catch (error) {
        console.error('Error cargando traducciones:', error);
      } finally {
        setLoading(false);
      }
    };

    if (keys.length > 0) {
      loadTranslations();
    }
  }, [keys.join(','), configuration, languageId]);

  return { translations, loading };
};

export default useTranslations;
